angular.module('am4').filter('errorCodeKey', function($translate, errorCodeConvertFilter) {
    return function(error_code) {

        var key = 'ERROR_CODE_' + errorCodeConvertFilter(error_code),
            translation = $translate.instant(key);

        if (translation !== key) {
            // successful match to error description translation
            return key.replace('ERROR_CODE_', '');
        }

        return null;
    };
});



// WEBPACK FOOTER //
// ./src/app/filters/errorCodeKey.js